import { jsx, jsxs } from "react/jsx-runtime";
import { Alert, AlertTitle } from "@mui/material";
import { useTexts } from "./useTexts.js";
function GracePeriodAlert(props) {
  const { gracePeriod, gracePeriodUnit = "day" } = props;
  const texts = useTexts();
  const title = typeof texts.title === "function" ? texts.title(gracePeriod, gracePeriodUnit) : "";
  return /* @__PURE__ */ jsxs(Alert, { severity: "warning", sx: { width: "100%" }, children: [
    /* @__PURE__ */ jsx(AlertTitle, { children: title }),
    texts.message
  ] });
}
export {
  GracePeriodAlert
};
//# sourceMappingURL=GracePeriodAlert.js.map
